import {createFileRoute, Outlet} from '@tanstack/react-router';
import {isPaymentMode} from 'features/shared/payment/types/PaymentMode';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/_statuses',
)({
  validateSearch: (search) => {
    return {
      paymentId: `${search.paymentId}`,
      paymentMode: isPaymentMode(search.paymentMode)
        ? search.paymentMode
        : 'openbanking_sessionless',
    };
  },
  component: Outlet,
});
